
// /* eslint-disable no-useless-concat */
// import { useNavigate } from 'react-router-dom';
// import { useEffect } from 'react';
// import { APP_PREFIX_PATH } from '../../config/AppConfig';
// function Authentication() {
//     const navigate = useNavigate();
//     console.log('auth page enter');

//     useEffect(() => {
//         const path = window.location.pathname;
//         const protectedPaths = [
//             '/Home',
//             APP_PREFIX_PATH + '/users',
//             APP_PREFIX_PATH + '/exporters',
//             APP_PREFIX_PATH + '/traders',
//             APP_PREFIX_PATH + '/retailers',
//             APP_PREFIX_PATH + '/categories',
//             APP_PREFIX_PATH + '/user-categories',
//             APP_PREFIX_PATH + '/manage_brand',
//             APP_PREFIX_PATH + '/sub-brands',
//             APP_PREFIX_PATH + '/broadcast',
//             APP_PREFIX_PATH + '/manage-products',
//             APP_PREFIX_PATH + '/manage-subscription',
//             APP_PREFIX_PATH + '/manage-user-subscription',
//             APP_PREFIX_PATH + '/manage-content',
//             APP_PREFIX_PATH + '/manage-banner',
//             APP_PREFIX_PATH + '/manage-contact',
//             APP_PREFIX_PATH + '/product-analytics',
//             APP_PREFIX_PATH + '/edit-subscription/:subscription_id',
//             APP_PREFIX_PATH + '/edit-subscription',
//             APP_PREFIX_PATH + '/add-subscription',
//             APP_PREFIX_PATH + '/view-product/:product_id',
//             APP_PREFIX_PATH + '/view-product',
//             APP_PREFIX_PATH + '/edit-product/:product_id',
//             APP_PREFIX_PATH + '/edit-product',
//             APP_PREFIX_PATH + '/view-user/:user_id',
//             APP_PREFIX_PATH + '/view-user',
//             APP_PREFIX_PATH + '/profile',
//         ];

//         const token = sessionStorage.getItem('token');
//         const userType = sessionStorage.getItem('user_type');

//         console.log('Current Path:', path);
//         console.log('Token:', token);

//         if (!token) {
//             if (![`/${APP_PREFIX_PATH}`, `/${APP_PREFIX_PATH}` + '/', `/${APP_PREFIX_PATH}` + '/forgot-password', `/${APP_PREFIX_PATH}` + '/reset-password'].includes(path)) {
//                 console.log('Navigating to /');
//                 navigate(APP_PREFIX_PATH + '/');
//             }
//         } else {
//             if ([`/${APP_PREFIX_PATH}`, `/${APP_PREFIX_PATH}` + '/', `/${APP_PREFIX_PATH}` + '/reset-password', `/${APP_PREFIX_PATH}` + '/forgot-password'].includes(path)) {
//                 console.log('Navigating to Home since token is present');
//                 navigate(`/${APP_PREFIX_PATH}` + '/Home');
//             }

//             // Check for protected paths and user type validity
//             if (protectedPaths.some((protectedPath) => path.startsWith(protectedPath))) {
//                 console.log('Protected path');
//                 if (userType !== '0' && !token) {
//                     console.log('Invalid user type, navigating to /logout');
//                     navigate(APP_PREFIX_PATH + '/');
//                 }
//             }
//         }
//     }, [navigate]);

//     return null;
// }

// export default Authentication;

import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { APP_PREFIX_PATH } from "../../config/AppConfig";

function Authentication() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const path = location.pathname;

    const publicPaths = [
      `/${APP_PREFIX_PATH}/`,
      `/${APP_PREFIX_PATH}/login`,
      `/${APP_PREFIX_PATH}/register`,
    ];

    if (!token && !publicPaths.includes(path)) {
      navigate(`/${APP_PREFIX_PATH}/`); // redirect to Home if no token
    }

    if (token && path === `/${APP_PREFIX_PATH}/login`) {
      navigate(`/${APP_PREFIX_PATH}/`); // redirect to Home if already logged in
    }
  }, [navigate, location]);

  return null;
}

export default Authentication;
